export default class DarkMode {
  constructor(element) {
    this.element = element;
    this.body = document.body;
    this.darkModeButton = this.element.querySelector('.button-dark-mode');
    this.darkModePreference = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;

    this.init();
  }

  init() {
    this.darkModeButton.addEventListener('click', this.toggleMode.bind(this));
    if (this.darkModePreference) {
      this.body.classList.add('dark-mode');
    }
  }

  toggleMode() {
    const isDark = this.body.classList.contains('dark-mode');

    this.body.classList.remove('dark-mode');

    if (!isDark) {
      this.body.classList.add('dark-mode');
    }
  }
}
